import { useParams } from 'react-router-dom'
import MoroccoForm from "../groupForm/MoroccoForm";
import IndiaForm from "../groupForm/IndiaForm";
import UnitedKingdomForm from "../groupForm/UnitedKingdomForm";
import TanzaniaForm from "../groupForm/TanzaniaForm";
import SriLankaForm from "../groupForm/SriLankaForm";
import VietnamForm from "../groupForm/VietnamForm";

const RedirectForm = () => {
  const { destination } = useParams();
  
  if (destination && destination.toLowerCase() === "india") return <IndiaForm />;
  if (destination && destination.toLowerCase() === "unitedkingdom") return <UnitedKingdomForm />;
  if (destination && destination.toLowerCase() === "tanzania") return <TanzaniaForm />;
  if (destination && destination.toLowerCase() === "srilanka") return <SriLankaForm />;
  if (destination && destination.toLowerCase() === "vietnam") return <VietnamForm />;
  if (destination && destination.toLowerCase() === "morocco") return <MoroccoForm />;
  return <MoroccoForm />;
}

export default RedirectForm
